export default __webpack_public_path__ + "static/media/img3.a537aea6.jpg";